import React from "react";
import { Link } from 'react-router-dom';
import IconBars from "./icons/IconBars";
import IconHistory from "./icons/IconHistory";
import IconPlus from "./icons/IconPlus";
import IconShoppingCart from "./icons/IconShoppingCart";

const FourCards = () => {
    // Styles pour les conteneurs d'icônes
    const iconContainerStyle = {
        width: "60px",
        height: "60px",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto 1.5rem auto",
        transition: "all 0.3s ease"
    };

    const cardsData = [
        { to: "/new_order", title: "Nouvelle Cmd", icon: <IconPlus />, color: "#fff3e0", iconColor: "#f5721e" },
        { to: "/available_menu", title: "Menus", icon: <IconBars />, color: "#e3f2fd", iconColor: "#2196f3" },
        { to: "/total_order", title: "Total Commandes", icon: <IconShoppingCart />, color: "#e8f5e9", iconColor: "#4caf50" },
        { to: "/historical", title: "Historiques", icon: <IconHistory />, color: "#f3e5f5", iconColor: "#9c27b0" }
    ];

    return (
        <>
            <div className="row mx-n2 mb-3">
                {cardsData.map((card, index) => (
                    <div className="col-lg-3 col-sm-6 px-2 mb-3" key={index}>
                        <Link to={card.to} className="text-decoration-none">
                            <div className="card h-100 border-0 shadow-sm custom-card">
                                <div className="card-body text-center p-4">
                                    <div 
                                        style={{ ...iconContainerStyle, backgroundColor: card.color, color: card.iconColor }}
                                        className="icon-wrapper"
                                    >
                                        {card.icon}
                                    </div>
                                    <h5 className="h5 font-weight-bolder text-dark mb-0">
                                        {card.title}
                                    </h5>
                                </div>
                            </div>
                        </Link>
                    </div>
                ))}
            </div>

            <style>{`
                .custom-card {
                    transition: transform 0.2s ease, box-shadow 0.2s ease;
                }
                .custom-card:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
                }
                .custom-card:hover .icon-wrapper {
                    transform: scale(1.1);
                }
            `}</style>
        </>
    );
};

export default FourCards;